import React from 'react';
import PropTypes from 'prop-types';

import numbering from 'sharedParts/utils/numbering';

import getSubLabelByType from '../../../../utils/getSubLabelByType';

const RatingScaleIndexItem = ({
  containerClassName,
  innerClassName,
  indexLabel,
  labelType,
  startFromZero,
}) => {
  const getIndexLabel = (index) => {
    const typeLabel = getSubLabelByType({ index, labelType, startFromZero });
    const noTypeLabel = startFromZero ? index : numbering.toHuman(index);
    return typeLabel || noTypeLabel;
  };

  return (
    <div
      className={containerClassName}
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <span className={innerClassName}>{getIndexLabel(indexLabel)}</span>
    </div>
  );
};

RatingScaleIndexItem.propTypes = {
  containerClassName: PropTypes.string,
  innerClassName: PropTypes.string,
  indexLabel: PropTypes.number,
  labelType: PropTypes.string,
  startFromZero: PropTypes.bool,
};

export default RatingScaleIndexItem;
